import { changeEmail, confirmChangeEmail } from "apis/authApi";
import { doCall } from "common/genericSaga";
import { getCurrentVendor, mapToMerchandiseVendors } from "helpers/vendorHelper";
import { all, call, put, takeEvery } from "redux-saga/effects";
import { oidc } from "services/oidcService";
import {
  CHANGE_EMAIL_REQUESTED,
  CHANGE_EMAIL_REQUEST_FAILED,
  CONFIRM_CHANGE_EMAIL_REQUESTED,
  CONFIRM_CHANGE_EMAIL_REQUEST_FAILED,
  errorChangeEmail,
  receiveChangeEmail,
  receiveConfirmChangeEmail
} from "./changeEmailActions";

export function* doChangeEmail(action, requestInfo) {
  const jwt = yield call(oidc.getCurrentUserJwt);
  const merchandiseVendor = mapToMerchandiseVendors(getCurrentVendor());
  const response = yield call(changeEmail, requestInfo, jwt.idp_type, jwt.idp_sub, action.email, merchandiseVendor);
  if (!response.success) {
    yield put(errorChangeEmail(action));
    return;
  }

  yield put(receiveChangeEmail());
}

export function* doConfirmChangeEmail(action, requestInfo) {
  const jwt = yield call(oidc.getCurrentUserJwt);
  yield call(confirmChangeEmail, requestInfo, jwt.idp_type, jwt.idp_sub, action.confirmationToken);
  yield put(receiveConfirmChangeEmail());
}

export function* watchChangeEmail() {
  yield all([
    takeEvery(CHANGE_EMAIL_REQUESTED, doCall(doChangeEmail, CHANGE_EMAIL_REQUEST_FAILED)),
    takeEvery(CONFIRM_CHANGE_EMAIL_REQUESTED, doCall(doConfirmChangeEmail, CONFIRM_CHANGE_EMAIL_REQUEST_FAILED))
  ]);
}
